<template>
  <div>
  </div>
</template>
<script>

export default {
  // Default client extra
  name: 'defaultExtra',
  props: ['value'],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
</style>
